export default "__VITE_ASSET__BzeINwTP__"